<template>
	<ElButton :class="{'button' : !noStyle, 'button--no-style': noStyle}" @click="handleClick">
		<span v-if="$slots.icon" class="button__icon"><slot name="icon" /></span>
		<span v-if="!noStyle" class="button__text"><slot></slot></span>
		<slot v-else />
		<span v-if="$slots.icon2" class="button__icon"><slot name="icon2" /></span>
		<slot name="status-icon" />
	</ElButton>
</template>

<script lang="ts">
	// eslint-disable-next-line no-restricted-imports -- type only
	import type Vue from 'vue';
	import { defineComponent, type DefineComponent } from 'vue';
	import { type ButtonHTMLAttributes } from 'vue/types/jsx';
	import { Button as ElButton } from '@cognitoforms/element-ui';

	type ElButtonProps = Omit<InstanceType<typeof ElButton>, keyof Vue>;

	type ElButtonAttrs = Omit<ButtonHTMLAttributes, keyof ElButtonProps> & Partial<ElButtonProps>;

	type CButtonProps = ElButtonAttrs & {
		noStyle?: boolean;
	};

	export default defineComponent({
		name: 'CButton',
		components: {
			ElButton
		},
		props: {
			noStyle: {
				type: Boolean,
				default: false
			}
		},
		emits: ['click'],
		methods: {
			handleClick(e: MouseEvent) {
				this.$emit('click', e);
			}
		}
	}) as unknown as DefineComponent<CButtonProps>;
</script>

<style lang="scss">
	.button__icon,
	.button__text,
	.button__icon *,
	.button__text * {
		pointer-events: none;
	}
</style>
